import type { IconData } from '@stacksjs/iconify-core'

export const contentVolumeHigh: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m3.5 4l4-4v16l-4-4H0V4zM9 1a7 7 0 1 1 0 14v-2.5a4.5 4.5 0 1 0 0-9z\"/><path fill=\"currentColor\" d=\"M9 5a3 3 0 1 1 0 6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentVolumeHigh
